import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/index.css";
import Navbar from "@/components/sections/Navbar";
import Hero from "@/components/sections/Hero";
import NoExcusas from "@/components/sections/NoExcusas";
import Centros from "@/components/sections/Centros";
import Transformaciones from "@/components/sections/Transformaciones";
import Mujeres from "@/components/sections/Mujeres";
import Servicios from "@/components/sections/Servicios";
import Testimonios from "@/components/sections/Testimonios";
import Contacto from "@/components/sections/Contacto";
import Footer from "@/components/sections/Footer";
import WhatsAppFab from "@/components/sections/WhatsAppFab";

function Landing() {
    return (
        <main className="bg-[#050505] text-brand-text font-body antialiased overflow-x-hidden">
            <Navbar />
            <Hero />
            <NoExcusas />
            <Centros />
            <Mujeres />
            <Transformaciones />
            <Servicios />
            <Testimonios />
            <Contacto />
            <Footer />
            <WhatsAppFab />
        </main>
    );
}

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Landing />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
